import { Injectable } from '@angular/core';
import { Feature } from 'ol';
import Geometry from 'ol/geom/Geometry';
import { GlobalSelectionControlService } from '../map/services/global-selection-control.service';
import { CoordinatePointModel } from '../models/coordinate-point';
import { NavaidModel } from '../models/navaid';
import { ToolsControlService } from './tools-control.service';
import {GritFeature} from "../models/grit/grit.feature";

@Injectable({
  providedIn: 'root'
})
export class MapSearchService {

  active : boolean;
  fullScreenMode : boolean = false;

  coordinatePoints : CoordinatePointModel[] = [];
  navaids : NavaidModel[] = [];

  previousSelectedNavaidFeature: Feature<Geometry>;
  previousSelectedNavaid: NavaidModel;

  previousSelectedCoordinatePointFeature: Feature<Geometry>;
  previousSelectedCoordinatePoint: CoordinatePointModel;

  //#region GRIT
  gritSearched = {
    elements: [] as GritFeature<any>[],
    selected: null as Feature,
  }
  searchedProjection: string;
  //endregion

  constructor(
    private toolsService: ToolsControlService,
    private globalSelectionService : GlobalSelectionControlService
  ) { }

  openWindow():void {
    this.active = true;
    this.toolsService.navigationOnTop = true;
  }

  clearVariables() {
    if (this.previousSelectedNavaidFeature != null){
      this.globalSelectionService.removeSelectedFeature(this.previousSelectedNavaidFeature);
    }
    if (this.previousSelectedCoordinatePointFeature != null){
      this.globalSelectionService.removeSelectedFeature(this.previousSelectedCoordinatePointFeature);
    }
    this.navaids = [];
    this.coordinatePoints = [];
    this.previousSelectedNavaidFeature = undefined;
    this.previousSelectedNavaid = undefined;
    this.previousSelectedCoordinatePointFeature = undefined;
    this.previousSelectedCoordinatePoint = undefined;

    //#region GRIT
    this.gritSearched.elements = [];
    this.gritSearched.selected = null;
    this.searchedProjection = null;
    //endregion
  }

  cancelWindow():void{
    this.active = !this.active;
    this.toolsService.navigationOnTop = false;
    this.clearVariables();
  }
}
